export default "__VITE_ASSET__3a02f2b6__"